module.exports = __webpack_public_path__ + "static/media/CARD_SILVER@3x.292878df.png";